import { render, staticRenderFns } from "./FourhSettingsComp.vue?vue&type=template&id=e9118c22&scoped=true&"
import script from "./FourhSettingsComp.vue?vue&type=script&lang=js&"
export * from "./FourhSettingsComp.vue?vue&type=script&lang=js&"
import style0 from "./FourhSettingsComp.vue?vue&type=style&index=0&id=e9118c22&prod&scoped=true&lang=css&"
import style1 from "./FourhSettingsComp.vue?vue&type=style&index=1&id=e9118c22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9118c22",
  null
  
)

export default component.exports